/* this file is transformed by vux-loader */
/* eslint-disable */
// src/utils/map/map.config.js

export var MAP_CONFIG = {
  // 高德地图配置
  amap: {
    key: '4a1b93f9d1eb22bb4fa99070ed8f50f8',
    version: '1.4.15',
    url: function url(key) {
      return "https://webapi.amap.com/maps?v=1.4.15&key=".concat(key, "&plugin=AMap.Geocoder,AMap.PlaceSearch,AMap.DistrictSearch,AMap.Geolocation");
    },
    plugins: ['AMap.MarkerCluster', 'AMap.DistrictSearch'],
    // 预加载插件
    defaultCenter: [116.397428, 39.90923],
    zoom: 10
  },
  // 天地图配置
  tianditu: {
    tk: 'f704fadfa00c3d986530fe4d6e66c27d',
    version: '4.0',
    url: function url(tk) {
      return "https://api.tianditu.gov.cn/api?v=4.0&tk=".concat(tk);
    },
    defaultCenter: [116.407, 39.909],
    // WGS84 坐标
    zoom: 10
  },
  // 滴滴地图引擎
  dmap: {
    key: 'd8fe649dca7cb114ecad11903d0a187c',
    version: '1.0.0',
    securityJsCode: 'ea0bac81a238fc74d78babc6a9a5fe5f',
    url: function url(version) {
      return 'https://lbs.xiaojukeji.com/api/v2/static/loader.js?version=' + version;
    },
    defaultCenter: [116.407, 39.909],
    // WGS84 坐标
    zoom: 10
  },
  // 系统全局坐标系设定 (业务层输入标准)
  inputStandard: 'GCJ02' // 告诉系统：我们的数据库存的是火星坐标
};